module.exports = __webpack_public_path__ + "static/media/product.ada80356.png";